<template>
    <div class="h-screen-dis">
        <div ref="formContainer" :class="mainClass">
            <div v-if="siteInfo.ErrorMsg.length > 0" id="ci_error_msg" class="hwifMk">
                <div class="msg">{{ siteInfo.ErrorMsg }}</div>
                <div class="btn" @click="deleteError">X</div>
            </div>
            <main id="view-form-main" style="position: relative;">
                <Vueform ref="form" :disabled="true" :schema="formData"  v-model="submissionData" sync />
                <div class="ci-cover"></div>
            </main>
            <Files :files="formFiles" :img="false" :signature="false"></Files>
            <Files :files="formImages" :img="true" :signature="false"></Files>
            <Files :files="formSignature" :img="true" :signature="true"></Files>
            <KeyValue title="Submission Date" :value="submissionDate"></KeyValue>
            <Print :handlePrint="handlePrint"></Print>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Images from "../components/Images.vue";
import Files from "../components/Files.vue";
import KeyValue from "../components/KeyValue.vue";
import Print from "../components/Print.vue";
import { emptyData } from '../data';
import { apiConfig } from '../config/api';
import { getFormStatus, getFilesData, checkFilesSchema } from '../utilities/dataHelper';

export default {
    name: 'View',
    data() {
        return {
            mainClass: 'ci-form-main-iframe',
            formData: emptyData.schema,
            submissionData: {},
            siteInfo: {
                ErrorMsg: '',
                EnableSave: false
            },
            formInfo: {
                Title: 'My Form',
                //Id: parseInt(this.$route.params['formId'] || 0),
                Uid: this.$route.params['formId'],
                Id: 0,
                SiteId: 5,
                FolderId: 0,
                Data: '',
                HasPub: false,
                HasDraft: false
            },
            state: {
                resizeObserve: null
            },
            formFiles: [],
            formImages: [],
            formSignature: [],
            fileSchema: null,
            imageSchema: null,
            signatureSchema: null,
            submissionDate: ''
        }
    },
    components: {
        Images,
        Files,
        KeyValue,
        Print
    },
    methods: {
        deleteError() {
            this.siteInfo.ErrorMsg = '';
        },
        getFormSchema() {
            axios({
                method: 'get',
                url: `${apiConfig.GetApiUrl}/${this.formInfo.Uid}`,
            }).then((res) => {

                let result = res.data;

                const status = getFormStatus(result);
                const title = result.title;
                let _fromData = (result.data || "");
                if (_fromData.length < 100) {
                    _fromData = JSON.stringify(emptyData);
                }
                this.formInfo = {
                    Id: parseInt(result.id),
                    SiteId: parseInt(result.siteId || 5),
                    FolderId: parseInt(result.folderId),
                    Title: title,
                    Uid: this.$route.params["formId"],
                    Data: _fromData,
                    Status: status
                };


                let schema = JSON.parse(_fromData).schema;

                let fileSchema = {};
                let imageSchema = {};
                let signatureSchema = {};

                checkFilesSchema(fileSchema, imageSchema, signatureSchema, schema);
                
                this.fileSchema = fileSchema;
                this.imageSchema = imageSchema;
                this.signatureSchema = signatureSchema;

                this.formData = schema;

                this.getFormSubmission();


            }).catch(e => {
                console.error('[get form schema] error:', e);
                this.siteInfo.ErrorMsg = `getting form schema error: ${e.message}`;
                this.formData = emptyData.schema;
            });

        },
        getFormSubmission() {
            axios({
                method: 'get',
                url: `${apiConfig.GetSubmissionUrl}/${this.formInfo.Uid}`,
            }).then((res) => {
                const data = this.findSubmission(res.data);

                this.submissionData = data;

                this.showFormFiles(data);

                this.submissionDate = data?.SubmissionDate || '';

                // fix phone number review
                setTimeout(() => {
                    this.$refs.form.update(data);
                }, 100);

            }).catch((err) => {
                console.error('[get form submission] error:', err);
                this.siteInfo.ErrorMsg = `getting form submission error: ${err.message}`;
            });
        },
        showFormFiles(data){
            this.formFiles = getFilesData(this.fileSchema, data);
            this.formImages = getFilesData(this.imageSchema, data);
            this.formSignature = getFilesData(this.signatureSchema, data);
        },
        findSubmission(data) {
            try {
                let id = parseInt(this.$route.params['itemId']);
                let pageId = parseInt(this.$route.params['pageId']);
                if (data && data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (item.id === id && item.pageId == pageId) {
                            
                            let res = JSON.parse(item.data);

                            let date = new Date(item.utc);
                            res.SubmissionDate = date.toLocaleString();

                            return res;
                            //return formatViewData(res);
                        }
                    }
                }
                return null;

            } catch (e) {
                console.error('[find submission] error:', e);
                this.siteInfo.ErrorMsg = `submission not found, id: ${this.$route.params['itemId']}`;
                return null;
            }
        },
        loadEmptyData() {
        },
        handlePrint() {
            window.print();
        }
    },
    created() {

    },
    async mounted() {

        this.$nextTick(() => {

            if (!this.state.resizeObserve) {
                this.state.resizeObserve = new ResizeObserver((entires) => {
                    for (const entry of entires) {
                        if (entry.target === this.$refs.formContainer) {
                            let formHeight = this.$refs.formContainer?.offsetHeight;
                            if (formHeight) {
                                let formId = this.formInfo.Id;
                                let cbMsg = {
                                    type: 'Form.Resize',
                                    id: formId,
                                    val: formHeight + 10
                                };
                                console.info('[postMessage]', cbMsg);
                                parent.postMessage(cbMsg, "*")

                            }
                        }
                    }
                });
            }
            this.state.resizeObserve.observe(this.$refs.formContainer);
        });
        this.getFormSchema();

    },
}
</script>